import FAQ from './FAQ';

export default FAQ;



// WEBPACK FOOTER //
// ./src/pages/LegalDocuments/FAQ/index.js